

// import { useMemo } from "react";

// export const usePaginationEngine = (state, isStacked, headerLayout) => {
//     return useMemo(() => {
//         // safely fallback to empty string if state is undefined
//         const bodyText = state?.body || "";
//         const chunks = [];
//         let remainingText = bodyText.trim();

//         if (!remainingText) return ["[Letter body will appear here...]"];

//         const LINE_HEIGHT_PX = 25; 
//         const CHARS_PER_LINE = 100;
//         const PARAGRAPH_MARGIN = 6;  

//         let headerOffset = isStacked ? 130 : 50;
//         const PAGE_CAPACITY = 760 - headerOffset;

//         let introCost = 100; 
//         if (state?.recipientName) introCost += 26;
//         if (state?.recipientAddress) introCost += (state.recipientAddress.split('\n').length * LINE_HEIGHT_PX);
//         if (state?.subject) introCost += 35;
//         if (state?.recipientEmail) introCost += 25;

//         let CAP_SIG = 180; 
//         if (state?.signatureType === 'esign') {
//             CAP_SIG = 220; 
//         } else if (state?.signatureType === 'send_link' && state?.signatories?.length) {
//             const rows = Math.ceil(state.signatories.length / 3);
//             CAP_SIG = 40 + (rows * 120); 
//         }

//         const CAP_FIRST = Math.max(150, PAGE_CAPACITY - introCost);
//         const CAP_OTHER = PAGE_CAPACITY;

//         let pageIndex = 0;

//         while (remainingText.length > 0) {
//             let currentCap = (pageIndex === 0) ? CAP_FIRST : CAP_OTHER;
//             const mode = state?.signaturePlacement || 'last_page';
//             let reserveSignature = false;
//             let forceExtraPage = false;

//             if (mode === 'all_pages' || (mode === 'first_page' && pageIndex === 0) || (mode === 'first_two' && pageIndex <= 1) || (mode === 'specific' && (pageIndex + 1) === Number(state?.signaturePagePoint || 0)) || (mode === 'first_last' && pageIndex === 0)) {
//                 reserveSignature = true;
//             }

//             const remainingParagraphs = remainingText.split('\n');
//             let totalRemainingCost = 0;
//             remainingParagraphs.forEach(p => {
//                 const lines = Math.max(1, Math.ceil(p.length / CHARS_PER_LINE));
//                 totalRemainingCost += (lines * LINE_HEIGHT_PX) + PARAGRAPH_MARGIN;
//             });

//             if (mode === 'last_page' || mode === 'first_last') {
//                 if (totalRemainingCost <= (currentCap - CAP_SIG)) {
//                     reserveSignature = true;
//                 } else if (totalRemainingCost <= currentCap) {
//                     if (!(mode === 'first_last' && pageIndex === 0)) reserveSignature = false;
//                     forceExtraPage = true;
//                 }
//             }

//             if (reserveSignature) currentCap -= CAP_SIG;

//             let currentCost = 0;
//             let splitIndex = remainingText.length;
//             let currentIndexTracker = 0;

//             if (totalRemainingCost > currentCap) {
//                 for (let i = 0; i < remainingParagraphs.length; i++) {
//                     const p = remainingParagraphs[i];
//                     const lines = Math.max(1, Math.ceil(p.length / CHARS_PER_LINE));
//                     const pCost = (lines * LINE_HEIGHT_PX) + PARAGRAPH_MARGIN;

//                     if (currentCost + pCost > currentCap) {
//                         if (currentCost > 0) {
//                             splitIndex = currentIndexTracker;
//                         } else {
//                             const remainingSpace = currentCap;
//                             const allowedLines = Math.floor(remainingSpace / LINE_HEIGHT_PX);
//                             const targetChars = allowedLines * CHARS_PER_LINE;
//                             let cutPos = p.lastIndexOf(' ', targetChars);
//                             if (cutPos === -1 || cutPos > targetChars) cutPos = Math.min(targetChars, p.length);
//                             splitIndex = currentIndexTracker + cutPos;
//                         }
//                         break;
//                     } else {
//                         currentCost += pCost;
//                         currentIndexTracker += p.length + (i < remainingParagraphs.length - 1 ? 1 : 0);
//                         splitIndex = currentIndexTracker;
//                     }
//                 }
//             }

//             if (splitIndex <= 0 && remainingText.length > 0) {
//                 splitIndex = Math.min(CHARS_PER_LINE, remainingText.length);
//             }

//             const chunk = remainingText.substring(0, splitIndex).trim();
//             chunks.push(chunk);
//             remainingText = remainingText.substring(splitIndex).trim();

//             if (remainingText.length === 0 && forceExtraPage) chunks.push("");

//             pageIndex++;
//         }

//         return chunks;
//     }, [state, isStacked, headerLayout]);
// };

// import { useMemo } from "react";
 
/*
  CALIBRATION NOTES — these constants must match what the browser renders
  inside LetterPage exactly, or pagination will be off.
 
  Layout:
    A4 width  = 794px  (A4_WIDTH_PX)
    A4 height = 1123px (A4_HEIGHT_PX)
    px-20     = 80px left + 80px right  → content width = 634px
    py-6      = 24px top + 24px bottom  → 48px total vertical padding
    header    = 60–130px depending on isStacked
    footer    = ~40px
 
  Typography:
    font-sans text-[12pt] = 16px font size, proportional (not monospace)
    leading-[1.6]         = 16 × 1.6 = 25.6px ≈ 26px per line
    At 634px wide, 16px proportional font, ~90 chars fit per line.
    (The textarea in the form uses a monospace font which is wider —
     that's why it looked like fewer chars fit. The letter preview uses
     font-sans which is proportional and fits more.)
 
  Paragraph spacing:
    mb-2 = 8px bottom margin per paragraph
*/
 
import { useMemo } from "react";

/*
  CALIBRATION — must match LetterPage exactly:

  A4:       794 × 1123 px at 96 dpi
  px-20:    80px each side  →  content width = 634px
  py-6:     24px top + 24px bottom = 48px vertical padding
  font:     font-sans text-[12pt] = 16px proportional
  leading:  leading-[1.6] = 16 × 1.6 = 25.6 ≈ 26px per line
  mb-2:     8px paragraph bottom margin

  CHARS_PER_LINE for font-sans proportional at 634px / 16px ≈ 90 chars.

  However, when lines contain long unbroken strings (no spaces), those
  strings wrap at the character level (word-break: break-word).  We use
  the same 90-char estimate for wrapping because that's what the browser
  does — each 90-char chunk becomes one visual line.
*/

const A4_HEIGHT_PX   = 1123;
const FOOTER_HEIGHT  = 40;
const VERTICAL_PAD   = 48;
const LINE_HEIGHT_PX = 26;
const CHARS_PER_LINE = 90;
const PARA_MARGIN    = 8;

// Estimate how many visual lines a paragraph string will wrap into.
// For strings with spaces, words wrap naturally.
// For long unbroken strings, word-break:break-word splits at CHARS_PER_LINE.
const estimateLines = (p) => {
  if (p.length === 0) return 0.5; // blank line takes half a line height

  // Split on whitespace tokens and simulate wrapping
  const words = p.split(/\s+/).filter(Boolean);
  if (words.length === 0) return Math.ceil(p.length / CHARS_PER_LINE);

  let lines       = 1;
  let lineChars   = 0;

  for (const word of words) {
    // A single word longer than one line wraps character-by-character
    if (word.length > CHARS_PER_LINE) {
      // Flush current partial line if anything is on it
      if (lineChars > 0) { lines++; lineChars = 0; }
      lines    += Math.floor(word.length / CHARS_PER_LINE);
      lineChars = word.length % CHARS_PER_LINE;
      continue;
    }

    const needed = lineChars === 0 ? word.length : lineChars + 1 + word.length;
    if (needed > CHARS_PER_LINE) {
      lines++;
      lineChars = word.length;
    } else {
      lineChars = needed;
    }
  }

  return lines;
};

const paragraphCost = (p) =>
  estimateLines(p) * LINE_HEIGHT_PX + PARA_MARGIN;

const totalCost = (text) =>
  text.split("\n").reduce((sum, p) => sum + paragraphCost(p), 0);

export const usePaginationEngine = (state, isStacked, headerLayout) => {
  return useMemo(() => {
    const bodyText = state?.body || "";
    const chunks   = [];
    let remainingText = bodyText.trim();

    if (!remainingText) return ["[Letter body will appear here...]"];

    // ── Page vertical capacity ─────────────────────────────────────────
    const headerHeight  = isStacked ? 130 : 65;
    const PAGE_CAPACITY = A4_HEIGHT_PX - headerHeight - FOOTER_HEIGHT - VERTICAL_PAD;

    // ── DocumentIntro cost (first page only) ───────────────────────────
    let introCost = 0;
    if (state?.companyEmail)      introCost += LINE_HEIGHT_PX + 4;
    introCost += LINE_HEIGHT_PX + 4;        // date line
    introCost += 16;                        // gap date → recipient
    if (state?.sent_at)           introCost += LINE_HEIGHT_PX * 0.9 + 2;
    introCost += LINE_HEIGHT_PX + 4;        // recipientName
    if (state?.recipientAddress) {
      const lines = state.recipientAddress.split("\n").length;
      introCost += lines * (LINE_HEIGHT_PX * 0.75) + PARA_MARGIN;
    }
    introCost += 12;                        // gap end of recipient section
    if (state?.recipientEmail)    introCost += LINE_HEIGHT_PX * 0.9 + 12;
    if (state?.subject)           introCost += LINE_HEIGHT_PX + 12;
    introCost += LINE_HEIGHT_PX + 16;       // "Dear ..." + mb-4
    introCost += 16;                        // safety buffer

    // ── Signature block cost ───────────────────────────────────────────
    let CAP_SIG = 130;
    if (state?.signatureType === "draw" || state?.signatureType === "upload") {
      CAP_SIG = 170;
    } else if (state?.signatureType === "esign") {
      CAP_SIG = 210;
    } else if (state?.signatureType === "send_link" && state?.signatories?.length) {
      const rows = Math.ceil(state.signatories.length / 3);
      CAP_SIG = 50 + rows * 130;
    }

    const CAP_FIRST = Math.max(100, PAGE_CAPACITY - introCost);
    const CAP_OTHER = PAGE_CAPACITY;

    // ── Main loop ──────────────────────────────────────────────────────
    let pageIndex = 0;

    while (remainingText.length > 0) {
      let currentCap       = pageIndex === 0 ? CAP_FIRST : CAP_OTHER;
      const mode           = state?.signaturePlacement || "last_page";
      let reserveSignature = false;
      let forceExtraPage   = false;

      const isSpecificPage =
        mode === "specific" &&
        pageIndex + 1 === Number(state?.signaturePagePoint || 0);

      if (
        mode === "all_pages" ||
        (mode === "first_page"  && pageIndex === 0) ||
        (mode === "first_two"   && pageIndex <= 1)  ||
        isSpecificPage                              ||
        (mode === "first_last"  && pageIndex === 0)
      ) {
        reserveSignature = true;
      }

      const remainingCost = totalCost(remainingText);

      if (mode === "last_page" || mode === "first_last") {
        if (remainingCost <= currentCap - CAP_SIG) {
          reserveSignature = true;
        } else if (remainingCost <= currentCap) {
          if (!(mode === "first_last" && pageIndex === 0)) reserveSignature = false;
          forceExtraPage = true;
        }
      }

      if (reserveSignature) currentCap -= CAP_SIG;

      // ── Greedy paragraph split ─────────────────────────────────────
      const paragraphs = remainingText.split("\n");
      let usedCost     = 0;
      let charCount    = 0;
      let splitIndex   = remainingText.length; // default: all fits

      if (remainingCost > currentCap) {
        splitIndex = 0;
        for (let i = 0; i < paragraphs.length; i++) {
          const p     = paragraphs[i];
          const pCost = paragraphCost(p);

          if (usedCost + pCost > currentCap) {
            if (usedCost > 0) {
              // Break before this paragraph
              splitIndex = charCount;
            } else {
              // First paragraph alone overflows — split mid-word
              // Walk through the paragraph line by line (CHARS_PER_LINE chunks)
              // and accumulate until we exceed currentCap
              let charsUsed     = 0;
              let costSoFar     = 0;
              const words       = p.split(/\s+/).filter(Boolean);
              let lineChars     = 0;
              let lastSafeChar  = 0;

              for (const word of words) {
                // Handle words longer than a line (break-word behaviour)
                let remaining = word;
                while (remaining.length > 0) {
                  const chunk = remaining.substring(0, CHARS_PER_LINE - lineChars || CHARS_PER_LINE);
                  if (lineChars + chunk.length > CHARS_PER_LINE) {
                    costSoFar += LINE_HEIGHT_PX;
                    if (costSoFar > currentCap) break;
                    lastSafeChar = charsUsed;
                    lineChars    = 0;
                  }
                  lineChars  += chunk.length;
                  charsUsed  += chunk.length;
                  remaining   = remaining.substring(chunk.length);
                }
                if (costSoFar > currentCap) break;

                // Space between words
                const needed = lineChars + 1 + (words[words.indexOf(word) + 1]?.length || 0);
                if (needed > CHARS_PER_LINE) {
                  costSoFar += LINE_HEIGHT_PX;
                  if (costSoFar > currentCap) break;
                  lastSafeChar = charsUsed;
                  lineChars    = 0;
                }
                charsUsed++;  // the space
              }

              // Fallback: cut at character boundary
              splitIndex = charCount + Math.max(lastSafeChar, CHARS_PER_LINE);
            }
            break;
          }

          usedCost  += pCost;
          charCount += p.length + (i < paragraphs.length - 1 ? 1 : 0);
          splitIndex = charCount;
        }
      }

      // Safety: always advance
      if (splitIndex <= 0 && remainingText.length > 0) {
        splitIndex = Math.min(CHARS_PER_LINE, remainingText.length);
      }
      splitIndex = Math.min(splitIndex, remainingText.length);

      const chunk   = remainingText.substring(0, splitIndex).trim();
      chunks.push(chunk);
      remainingText = remainingText.substring(splitIndex).trim();

      if (remainingText.length === 0 && forceExtraPage) chunks.push("");

      pageIndex++;
    }

    return chunks;
  }, [state, isStacked, headerLayout]);
};